import axios from "axios";
import Config from "src/config";

const v1_actionMessengerCriarTemplate = (clienteId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v1/${clienteId}/canais/messenger/templates`,
        data
    });
};

export default v1_actionMessengerCriarTemplate;
